import * as actionTypes from "./OmniChannelsTypes";
import { Post, Get } from "../../helpers/apicalls/apicalls";
import { message } from 'antd';

export const AddUpdateWhatsapp = (data) => {
  return (dispatch) => {
    dispatch({ type: actionTypes.IS_LOADING_WHATSAPP });
    Post("/agents/whatsapp-config", data)
      .then(function (response) {
        if (response?.status) {
          dispatch({
            type: actionTypes.WHATS_APP_SUCCESS,
            payload: response?.data
          });
          message.success(`${response?.message}`);
        } else {
          dispatch({ type: actionTypes.WHATS_APP_FALED });
          message.error(`${response?.message}`);
        }
      })
      .catch(function (error) {
        dispatch({ type: actionTypes.WHATS_APP_FALED });
        message.error("something went wrong, please try again");
      });
  };
};

export const getOmni = (data) => {
  return (dispatch) => {
    Post("/agents/get-whatsappConfig", data)
      .then((res) => {
        if (res.status) {
          dispatch({
            type: actionTypes.OMNI_SUCCESS,
            payload: res.data
          });
        }
        else {
          dispatch({
            type: actionTypes.OMNI_FALED,
          });
        }
      })
      .catch((err) => {
        dispatch({
          type: actionTypes.OMNI_FALED,
        });
      });
  };
};

export const AddUpdatedEmail = (data) => {
  return (dispatch) => {
    dispatch({ type: actionTypes.IS_LOADING_EMAIL });
    Post("/agents/email-config", data)
      .then(function (response) {
        if (response?.status) {
          dispatch({
            type: actionTypes.EMAIL_SUCCESS,
            payload: response?.data
          });
          message.success(`${response?.message}`);
        } else {
          dispatch({ type: actionTypes.EMAIL_FALED });
          message.error(`${response?.message}`);
        }
      })
      .catch(function (error) {
        dispatch({ type: actionTypes.EMAIL_FALED });
        message.error("something went wrong, please try again");
      });
  };
};

export const getEmail = (data) => {
  return (dispatch) => {
    dispatch({ type: actionTypes.IS_LOADING_GET_EMAIL });
    Post("/agents/get-emailConfig", data)
      .then((res) => {
        if (res.status) {
          dispatch({
            type: actionTypes.GET_EMAIL_SUCCESS,
            payload: res.data
          });
        }
        else {
          dispatch({
            type: actionTypes.GET_EMAIL_FALED,
          });
        }
      })
      .catch((err) => {
        dispatch({
          type: actionTypes.GET_EMAIL_FALED,
        });
      });
  };
};


